import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export default function Tab({ className, selected = false, children, onClick }) {
	return (
		/* eslint-disable jsx-a11y/click-events-have-key-events */
		<a
			className={classnames(className, 'tab-carousel-tab', { selected })}
			onClick={onClick}
			role="button"
			tabIndex={0}
		>
			{children}
		</a>
		/* eslint-enable */
	);
}

Tab.propTypes = {
	className: PropTypes.string,
	selected: PropTypes.bool,
	onClick: PropTypes.func,
	children: PropTypes.node
};

